import React from 'react';

const LogoSvg = ({ fill = '#33658a', ...props }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 754.08 909.33" {...props}>
      <g id="Layer_2" data-name="Layer 2">
        <g id="SvgjsSvg47454">
          <g id="SvgjsG47456">
            <g id="SvgjsG14614">
              <g id="SvgjsG14615">
                <path
                  fill={fill}
                  d="M644,109.94C496.58-37.44,258.45-36.25,111.06,111.13S-37.36,497.19,110,644.54L376.3,909.33,643.13,642.46c147.39-147.39,148.2-385.13.84-532.52ZM377,698C198.76,698,54.23,553.46,54.23,375.18S198.77,52.32,377,52.32,699.85,196.86,699.85,375.18,555.32,698,377,698Z"
                />
                <path
                  fill={fill}
                  d="M359.08,145.57c13.8-11.82,38-7.85,45.83,9,15.86,39.29,31.44,78.71,47.2,118,.27,1.33,1.52,1.79,2.75,1.79,39.44,2.69,78.86,5.9,118.31,8.73,11.3.24,22.52,6.47,27.64,16.74,6.33,11.54,4.2,27.54-6.16,36.08-31.81,26.16-63.32,52.66-95,78.9a10.56,10.56,0,0,0-2.37,2.53c9,39,19,77.85,28.39,116.79,7.1,19.53-9.55,42.57-30.47,41-7.22-.09-13.52-4-19.27-8q-46.65-29.47-93.36-58.93c-2.65-1.63-5.15-3.67-8.13-4.62-35.3,21.24-70,43.46-105.24,64.89a31.08,31.08,0,0,1-32-.41c-10-6-16.18-18.27-13.83-29.87,10.14-41.62,21.55-83.08,31.24-124.78-28.6-24.62-57.63-48.72-86.36-73.16-6.5-5.29-13.57-10.8-16.39-19-6.9-16.5,4-38,22.1-40.58,43-3.64,86.36-5.17,129.28-9.11C318,236.16,332.27,200.41,347,164.83c2.74-7.12,5.88-14.52,12.12-19.26Z"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default LogoSvg
